import { PropsWithChildren, useMemo } from 'react';

import { AuthenticationContext } from '../contexts/authentication-context';

export const NoopAuthenticationContextProvider = ({ children }: PropsWithChildren) => {
   const value = useMemo(
      () => ({
         user: undefined,
         accessToken: undefined,
         loading: false,
         refreshToken: async () => {
            // no-op
         },
         login: () => {
            // no-op
         },
         logout: () => {
            // no-op
         }
      }),
      []
   );

   return <AuthenticationContext.Provider value={value}>{children}</AuthenticationContext.Provider>;
};
